import { render, staticRenderFns } from "./SiteSelectorInPage.vue?vue&type=template&id=089a0c0f&"
import script from "./SiteSelectorInPage.vue?vue&type=script&lang=js&"
export * from "./SiteSelectorInPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports